import {
  getArtworkHoldingType,
  getArtworkLimitedEditionOptions,
} from './artworkView.selectors';

export function isArtworkAuction(artwork) {
  return Boolean(
    artwork?.artwork_about?.artwork_is_auction
    || artwork?.artwork_auction?.is_enabled
    || artwork?.artwork_auction
  );
}

export function hasLimitedEditionVariants(options) {
  if (!options || typeof options !== 'object') {
    return false;
  }
  return Object.values(options).some((edition) => Boolean(edition));
}

export function shouldShowLimitedEditionIcon(artwork) {
  return Boolean(
    artwork?.artwork_has_limited_editions === true
    || getArtworkHoldingType(artwork) === 'limited_edition'
    || hasLimitedEditionVariants(getArtworkLimitedEditionOptions(artwork))
  );
}

export function getArtworkAuctionCta(artwork) {
  const about = artwork?.artwork_about ?? {};
  const auction = artwork?.artwork_auction ?? {};
  const isAuction = Boolean(about.artwork_is_auction);
  if (!isAuction) {
    return {
      isAuction: false,
      label: 'See auction',
      isClosed: false,
    };
  }

  const isEnabled = Boolean(auction.is_enabled);
  const hasClosedFlag = Boolean(auction.is_closed ?? auction.closed);
  const endsAtTimestamp = auction?.ends_at ? new Date(auction.ends_at).getTime() : NaN;
  const status = typeof (auction.state || auction.status) === 'string'
    ? (auction.state || auction.status).trim().toLowerCase()
    : '';
  const endedBySchedule = Number.isFinite(endsAtTimestamp) && endsAtTimestamp <= Date.now();
  const isClosed = Boolean(
    hasClosedFlag ||
    status === 'closed' ||
    status === 'ended' ||
    (endedBySchedule && !isEnabled)
  );

  return {
    isAuction: true,
    label: isClosed ? 'Auction Details' : 'See auction',
    isClosed,
  };
}
